export enum OAuthProviderEnum {
	Microsoft = 'microsoft',
	Google = 'google',
	Facebook = 'facebook',
}
